// extracted by mini-css-extract-plugin
export default {"checkpaymentcontainer":"Checkpayment_checkpaymentcontainer__D9Aht"};